import * as React from 'react';
import { Result } from './result';
import { ISearchResultHitDTO } from '../../DTO/search';

interface IProps {
    results: ISearchResultHitDTO[];
    hideCategories: boolean;
    onResultClick: (hitId) => void;
}

export class ResultList extends React.Component<IProps, any> {
    renderResults = ((result, index) =>
        <Result result={result} key={`${result.url} ${result.title} ${index}`} onClick={this.props.onResultClick} hideCategories={this.props.hideCategories } />
    );

    render() {
        return (
            <>
                <h2 className="visually-hidden">Search Results</h2>
                <ul className="adage-search-results" aria-live="polite">
                    {this.props.results.map(this.renderResults)}
                </ul>
            </>
        )
    }
}

